import { render } from "./collection-resource-delete.vue?vue&type=template&id=0ef54a0a"
import script from "./collection-resource-delete.vue?vue&type=script&lang=js"
export * from "./collection-resource-delete.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__